import { render, staticRenderFns } from "./TabOVHistorial.vue?vue&type=template&id=1bf07eac&scoped=true&lang=pug"
import script from "./TabOVHistorial.vue?vue&type=script&lang=js"
export * from "./TabOVHistorial.vue?vue&type=script&lang=js"
import style0 from "./TabOVHistorial.vue?vue&type=style&index=0&id=1bf07eac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf07eac",
  null
  
)

export default component.exports